import React from 'react'

// utils
import { createOrder } from './PurchaseOrderInfo.utils'

// query
import { useQuery } from '@apollo/client'
import { GET_EQUIPMENT_PURCHASE_ORDER_BY_ID_WITH_INFO } from '../../../../graphql/equipmentPurchaseOrder/equipmentPurchaseOrder.queries'

// components
import Card from '../../../../components/cards/Card/Card.component'
import CardDataPoint from '../../../../components/cards/CardDataPoint/CardDataPoint.component'

// icons
import { FontAwesomeIcon  } from '@fortawesome/react-fontawesome'
import { faInfo } from '@fortawesome/free-solid-svg-icons'

export default function PurchaseOrderInfo({ id }) {

    let order = {}

    const { loading, error, data } = useQuery(GET_EQUIPMENT_PURCHASE_ORDER_BY_ID_WITH_INFO, {
        variables: { id }
    })

    if(data && data.equipmentPurchaseOrder) {
        order = createOrder(data.equipmentPurchaseOrder)
    }

    return (<Card header={{icon: <FontAwesomeIcon icon={faInfo} size='2x' color='#707070' />, title: "Order"}}>
        <CardDataPoint label="Vendor" value={order.vendor} />
        <CardDataPoint label="Date" value={order.date} />
        <CardDataPoint label="Total $" value={order.totalAmount} />
        <CardDataPoint label="Status" value={order.status} />
        <CardDataPoint label="Date Received" value={order.dateReceived} />
    </Card>)
}